import script from "./CollectionsNavLink.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionsNavLink.vue?vue&type=script&setup=true&lang=js"

import "./CollectionsNavLink.vue?vue&type=style&index=0&id=64771297&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64771297"]])

export default __exports__